var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',{attrs:{"filterable":""}},[_vm._v(" Ordem Produção ")])
}
var staticRenderFns = []

export { render, staticRenderFns }